<div class="cx-modal-container">
  <div class="cx-modal-content">
    <div class="cx-dialog-header modal-header">
      <div></div>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="closeModal('close')"
      >
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="cx-dialog-body modal-body">
      <div class="row">
        <div class="auto-fill d-flex">
          <div class="vs-checkbox autofill-check-holder">
            <input
              id="check-autofill"
              type="checkbox"
              value="true"
              name="check-autofill"
              [(ngModel)]="checkAll"
              class="checkInput"
            />
            <label for="check-autofill" class="auto-fill-check"></label>
          </div>

          <div>
            <span class="auto-fill-para">{{
              'sharedComponents.autoFillNoPara' | cxTranslate
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="cx-dialog-footer modal-footer">
      <button
        class="vs-primary-btn"
        [disabled]="!checkAll"
        (click)="closeModal('confirm-autofill')"
      >
        <span>
          {{ 'sharedComponents.confirmBtn' | cxTranslate }}
        </span>
      </button>
    </div>
  </div>
</div>
